module.exports = __webpack_public_path__ + "static/media/Online Store 6.a6209b6d.png";